'use client';

import React, { useEffect, useRef } from 'react';

const cards = [
  {
    tag: 'Week 1-2',
    title: 'Clean restart',
    body: 'Verified calling data, your written meeting definition, and reps trained on your pitch. Nothing goes out until the targeting is right.',
  },
  {
    tag: 'First month',
    title: 'Live conversations begin',
    body: 'Your reps run phone-first cadences with email and LinkedIn in support, and every reply gets a human answer.',
  },
  {
    tag: 'Day 60-90',
    title: 'Steady state',
    body: 'Targeting tuned against real conversations, weekly reporting your closers can grade, and a month-to-month agreement that has to earn its renewal.',
  },
];

export default function WhatChangesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-16 bg-white">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[780px]">
          <div className="eyebrow">What changes</div>
          <h2 className="heading-2 text-ink">Same budget line. Different outcome.</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cards?.map((card, i) => (
            <div
              key={card?.tag}
              className="rev bg-white border border-line-color rounded-brand p-7"
              style={{ transitionDelay: `${i * 0.09}s` }}
            >
              <span className="block font-mono text-[11px] tracking-[0.18em] text-primary uppercase mb-3.5">
                {card?.tag}
              </span>
              <h3 className="heading-3 text-ink mb-3">{card?.title}</h3>
              <p className="text-[15px] text-muted-text leading-relaxed">{card?.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}